module.exports = __webpack_public_path__ + "static/media/countGuest.82c9eee6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/countGuest.svg
// module id = 889
// module chunks = 0